import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { AsyncPaginate } from "react-select-async-paginate";

const FetchServiceList = (props) => {
  const queryParams = new URLSearchParams(window.location.search);
  const accessToken = queryParams.get("userAuthToken");
  const [serviceComponentId, setServiceComponentId] = useState('');
  const [subServiceComponentId, setSubServiceComponentId] = useState('');
  
  useEffect(() => {
    setServiceComponentId(props.currentSystemCode);
    setSubServiceComponentId(props.currentSubSystemCode);
  }, [props, props.value, serviceComponentId, subServiceComponentId])

  const loadOptions = async (searchQuery, _, { page }) => {

    const response = await fetch(
      `/api/v1/service_codes/aar/services?sub_service_component=${subServiceComponentId ? subServiceComponentId : ''}&service_component=${serviceComponentId ? serviceComponentId : ''}&search=${searchQuery}&page=${page}`, {
      method: 'GET',
      headers: {
        'Access-Token': accessToken,
      },
    }
    );
    const responseJSON = await response.json();

    let options = responseJSON.services.map((option) => ({
      label: `${option.name}`,
      value: `${option.id}`,
      data: option
    }))

    return {
      options: options,
      hasMore: responseJSON.meta.has_more,
      additional: {
        page: page + 1,
      },
    };
  };

  const onChange = (option) => {
    if (typeof props.onChange === "function") {
      props.onChange(option);
    }
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      background: '#fff',
      borderColor: '#5195FB',
      minHeight: '30px',
      height: '30px',
      boxShadow: state.isFocused ? null : null,
    }),

    valueContainer: (provided, state) => ({
      ...provided,
      height: '30px',
      padding: '0 6px'
    }),

    input: (provided, state) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: state => ({
      display: 'none',
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: '30px',
    }),
  };

  return (
    <>
      { typeof (props.value) === 'string' ?
        <AsyncPaginate
          key={JSON.stringify(serviceComponentId)}
          defaultValue={{ value: props.value, label: props.value }}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Service"
          className='service_dropdown'
          styles={customStyles}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        /> :

        <AsyncPaginate
          key={JSON.stringify(serviceComponentId)}
          value={props.value}
          loadOptions={loadOptions}
          onChange={onChange}
          isSearchable={true}
          placeholder="Service"
          className='service_dropdown'
          styles={customStyles}
          debounceTimeout={500}
          additional={{
            page: 1,
          }}
        />
      }
    </>
  );
};

FetchServiceList.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  currentSystemId: PropTypes.number,
  currentSubSystemId: PropTypes.number
};

export default FetchServiceList;